import { render, staticRenderFns } from "./MarqetaDisplayCard.vue?vue&type=template&id=4d86f88c&scoped=true"
import script from "./MarqetaDisplayCard.vue?vue&type=script&lang=js"
export * from "./MarqetaDisplayCard.vue?vue&type=script&lang=js"
import style0 from "./MarqetaDisplayCard.vue?vue&type=style&index=0&id=4d86f88c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d86f88c",
  null
  
)

export default component.exports